<template lang="pug">
  v-app-bar.pr-0(color="primary" app flat)
    v-img.mr-4.cursor(:src="require('@/assets/logo.png')" @click="gotoHome" contain max-width="80")
    v-toolbar-title.subheading.white--text.cursor(@click="gotoHome") Tour Guide App
    v-spacer
    v-toolbar-items(v-if="$store.state.user")
      v-menu(:nudge-width="80" offset-y)
        template(v-slot:activator="{ on }")
          v-app-bar-nav-icon.mr-0.white--text(v-on="on")
        v-list
          v-list-item(@click="$router.push({ name: 'home' })")
            v-list-item-title Trip List
          v-list-item(@click="$router.push({ name: 'payoutHistory' })")
            v-list-item-title Payout History
          v-divider
          v-list-item(@click="$router.push({ name: 'profile' })")
            v-list-item-title My Profile
          v-list-item(@click="logOut")
            v-list-item-title Log Out
            v-icon(small) mdi-logout
</template>

<script>
export default {
  data: () => ({
  }),
  methods: {
    logOut () {
      this.$store.commit('setUser', null)
      this.$router.push({ 'name': 'login' })
      this.$emit('snackbar', 'Log out successful')
    },
    gotoHome () {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss">
.v-toolbar__content {
  padding-right: 0px;
  border-bottom: 1px solid rgba(0,0,0,0.12);
}

.cursor {
  cursor: pointer;
}


.default-text-case {
  text-transform: none;
}
</style>
